import { useEffect } from 'react';

// Global performance optimizations component
const GlobalOptimizations = () => {
  useEffect(() => {
    
    // Preload critical resources
    const preloadCriticalResources = () => {
      // Preload hero image
      const heroImg = new Image();
      heroImg.src = '/src/assets/hero-image.jpg';

      // Preload Google Fonts
      const fontLink = document.createElement('link');
      fontLink.rel = 'preload';
      fontLink.as = 'font';
      fontLink.type = 'font/woff2';
      fontLink.crossOrigin = 'anonymous';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(fontLink);
    };

    // Optimize images with lazy loading
    const optimizeImages = () => {
      const images = document.querySelectorAll('img[data-src]');
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target as HTMLImageElement;
            img.src = img.dataset.src!;
            img.classList.remove('opacity-0');
            img.classList.add('opacity-100');
            imageObserver.unobserve(img);
          }
        });
      });

      images.forEach(img => imageObserver.observe(img));
    };

    // Service worker registration was removed: the prior cache-first SW pinned
    // users to stale index.html referencing rotated-out bundle hashes, causing
    // blank pages after deploys. /sw.js still exists as a self-unregistering
    // kill switch so already-installed clients clean up on their next visit.

    // Track scroll depth for engagement (moved to individual pages)
    // This prevents multiple tracking instances

    // Critical resource hints
    const addResourceHints = () => {
      // DNS prefetch for external domains
      const dnsPrefetchDomains = [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com',
        'https://www.google-analytics.com'
      ];

      dnsPrefetchDomains.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      });

      // Preconnect to critical domains
      const preconnectDomains = [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com'
      ];

      preconnectDomains.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      });
    };

    // Initialize optimizations
    preloadCriticalResources();
    optimizeImages();
    addResourceHints();

    // Removed scroll tracking to prevent multiple instances
  }, []);

  return null; // This component doesn't render anything
};

export default GlobalOptimizations;